(() => {
  if (customElements.get('niwa-product-details')) return;
  class NiwaProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.dataset.arranged) return;
      this.dataset.arranged = 'true';
      const source = this.querySelector('[data-description-source]');
      if (!source) return;
      // Replace old per-product shipping directions with the shared current estimator.
      source.querySelectorAll('tr').forEach(row => {
        const heading = row.querySelector('th');
        const cell = row.querySelector('td');
        if (heading && cell && /^(別途送料|送料|配送方法)$/.test(heading.textContent.trim())) {
          const link = document.createElement('a');
          link.href = '#niwa-shipping-product';
          link.textContent = '購入欄の「宅配便の目安送料」でご確認ください。大型配送は別途お見積もりします。';
          cell.replaceChildren(link);
        }
      });
      // Keep the actual table nodes, including shipping links, calculators and event listeners.
      const tables = [...source.querySelectorAll('table')].filter(table => {
        if (table.parentElement.closest('table')) return false;
        const headers = [...table.querySelectorAll('th')].map(th => th.textContent.trim());
        return headers.some(text => /^(サイズ|重量|色|材質|石種|用途|販売単位|仕様)/.test(text)) && !headers.some(text => /地域|運賃/.test(text));
      });
      if (tables.length) {
        tables.forEach(table => this.querySelector('[data-spec-content]').append(table));
        this.querySelector('[data-specs]').hidden = false;
        this.querySelector('[data-spec-link]').hidden = false;
      }
      // Only remove gallery duplicates when their original filename appears in the primary gallery.
      const canonical = value => {
        try { return decodeURIComponent(new URL(value, location.href).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.)/, '').toLowerCase(); }
        catch { return value; }
      };
      const main = this.closest('product-info');
      const primary = new Set([...main.querySelectorAll('.product__media-wrapper img')].map(img => canonical(img.currentSrc || img.src)));
      const seen = new Set();
      source.querySelectorAll('ol[id="sample-list"]').forEach(list => {
        list.querySelectorAll('img').forEach(img => {
          const key = canonical(img.src);
          if (primary.has(key) || seen.has(key)) return;
          seen.add(key);
          const figure = document.createElement('figure');
          const anchor = img.closest('a');
          if (!img.alt) img.alt = document.querySelector('.product__title h1')?.textContent.trim() || '商品の追加写真';
          img.loading = 'lazy';
          img.removeAttribute('width'); img.removeAttribute('height');
          figure.append(anchor || img);
          this.querySelector('[data-photo-content]').append(figure);
        });
        // Preserve any non-photo text rather than silently discarding it.
        if (!list.textContent.trim() && !list.querySelector('video,iframe,model-viewer,audio')) list.remove();
      });
      if (seen.size) {
        this.querySelector('[data-photos]').hidden = false;
        this.querySelector('[data-photo-link]').hidden = false;
      }
      // Hide empty legacy layout wrappers left by moved images and specification tables.
      [...source.querySelectorAll('ol, p')].forEach(node => {
        if (!node.textContent.trim() && !node.querySelector('img,video,iframe,input,select,button')) node.remove();
      });
    }
  }
  customElements.define('niwa-product-details', NiwaProductDetails);
})();
